<template>
  <section class="cs-loader" :class="{ 'cs-loader_hidden': hidden }">
    <!-- <router-link v-if="exit" class="cs-loader__settings" @click.capture="handleSettingEvent" :to="{ name: 'Settings' }">
      <img src="@/assets/img/settings.svg" alt="settings">
    </router-link> -->
    <!-- <button v-if="exit" class="cs-loader__btn" @click="close()">
      <img src="@/assets/img/close.svg" alt="close">
    </button> -->
    <div class="cs-loader__wrap" :class="{ 'cs-loader__animation-end': finish }">
      <div class="cs-loader__box">
        <div class="cs-loader__item cs-loader__item_1" />
        <div class="cs-loader__item cs-loader__item_2" />
        <div class="cs-loader__item cs-loader__item_3" />
        <div class="cs-loader__item cs-loader__item_4" />
      </div>
    </div>
    <!-- <div class="cs-loader__messages">
      <div v-for="(message, i) in messages" :key="i" class="cs-loader__message"
        :class="{ 'cs-loader__message_error': exit }">
        {{ message }}
      </div>
      <div v-if="waitingMessage" class="cs-loader__waiting-msg">
        {{ $t(waitingMessage) }}
      </div>
    </div> -->
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { USER_TRACK_EVENTS } from '../store/modules/user/consts';

export default {
  data() {
    return {
      hidden: false,
      finish: false,
      exit: false,
      timeout: null,
      messages: [],
      waitingMessage: '',
    };
  },
  mounted() {
    this.addMessageHandler = (data) => {
      this.addMessage(data.message);
    };
    this.DeleteMessageHandler = (data) => {
      this.deleteMessage(data.message);
    };
  },
  computed: {
    ...mapGetters({
      paymentCompleted: 'auth/paymentCompleted',
    }),
  },
  methods: {
    addMessage(message) {
      this.messages.push(message);
    },
    deleteMessage(message) {
      const index = this.messages.findIndex((el) => el === message);
      if (index !== -1) this.messages.splice(index, 1);
    },
    deleteAllMessages() {
      this.messages = [];
    },
    start(messageKey = '') {
      this.waitingMessage = messageKey;
      this.deleteAllMessages();
      // window.EventBus.on('ADD_INFO_MESSAGE', this.addMessageHandler);
      // window.EventBus.on('DELETE_INFO_MESSAGE', this.DeleteMessageHandler);
      this.hidden = false;
      this.finish = false;
      this.exit = false;
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.showExit();
      }, 60000);
    },
    end() {
      this.deleteAllMessages();
      // window.EventBus.off('ADD_INFO_MESSAGE', this.addMessageHandler);
      // window.EventBus.off('DELETE_INFO_MESSAGE', this.DeleteMessageHandler);
      this.finish = true;
      this.exit = false;
      if (this.timeout) clearTimeout(this.timeout);
      setTimeout(() => {
        this.hidden = true;
      }, 320);
    },
    hide() {
      if (this.timeout) clearTimeout(this.timeout);
      this.exit = false;
      this.hidden = true;
      this.finish = true;
    },
    showExit() {
      this.exit = true;
      this.deleteAllMessages();
      this.addMessage('Something went wrong...');
      this.addMessage('close the window and try again please');
    },
    async handleSettingEvent() {
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: 'Payment Page',
          activity: 'clicked on setting button',
        },
      });
    },
    close() {
      this.notifyParentWindow({
        type: 'rocketfuel_iframe_close',
        paymentCompleted: this.paymentCompleted,
      });
      this.$store.dispatch(`user/${USER_TRACK_EVENTS}`, {
        moduleInfo: {
          current: this.$route.name,
          activity: 'clicked exit button',
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$default-container-width: 100%;
$default-margin-left: -20px;
@keyframes loader {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes end {
  0% {
    width: 66px;
    height: 66px;
  }

  100% {
    width: 17px;
    height: 17px;
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

.cs-loader {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: $white;
  z-index: 1000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: auto;
  // margin-left: $default-margin-left;

  // @media (max-width: 1024px) {
  //   margin: auto;
  //   width: $default-container-width;
  //   left: unset;
  //   margin-left: $default-margin-left;
  //   /* Adjust the width for tablets */
  // }

  // @media (max-width: 768px) {
  //   width: $default-container-width;
  //   left: unset;
  //   /* Adjust the width for standard mobile devices */
  //   margin: auto;
  //   margin-left: $default-margin-left;
  // }

  // @media (max-width: 480px) {
  //   width: 100%;
  //   /* Adjust the width for small mobile devices */
  //   height: 100vh;
  //   left: 0;
  //   margin: auto;
  //   margin-left: $default-margin-left;
  // }

  &_hidden {
    display: none;
  }

  &__wrap {
    width: 66px;
    height: 66px;
  }

  &__box {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    animation: loader 1.6s cubic-bezier(0.6, 0, 0.4, 1) infinite,
      opacity 1.6s;
  }

  &__animation-end {
    animation: end .32s ease-in;
  }

  &__messages {
    position: absolute;
    top: calc(50% + 60px);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &__message {
    font-size: 14px;

    &_error {
      color: $red500;
    }
  }

  &__waiting-msg {
    padding: 20px;
    text-align: center;
  }

  &__btn {
    @include gradient-box;
    background-color: $white;
    width: 30px;
    min-width: 30px;
    height: 30px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s;
    position: fixed;
    top: 15px;
    right: 20px;

    & img {
      width: 12px;
    }

    &:hover {
      background-color: $gradient-grey;
    }
  }

  &__settings {
    @include gradient-box;
    background-color: $white;
    width: 30px;
    min-width: 30px;
    height: 30px;
    object-fit: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s;
    position: fixed;
    top: 15px;
    right: 60px;

    &:hover {
      background-color: $gradient-grey;

      & img {
        animation: rotate 1.25s linear infinite;
      }
    }
  }

  &__item {
    position: absolute;
    width: 17px;
    height: 17px;
    border-radius: 50%;

    &_1 {
      bottom: 0;
      left: 0;
      background-color: $black200;
    }

    &_2 {
      bottom: 0;
      right: 0;
      background-color: $black300;
    }

    &_3 {
      top: 0;
      right: 0;
      background-color: $black400;
    }

    &_4 {
      top: 0;
      left: 0;
      background-color: $black600;
    }
  }
}
</style>
